export const isFullStatic = false
export const staticPath = "/Users/katsumoto/Dev/vsf/scripts/deploy/tmp/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"